// 监听元素进入视窗动画
window.addEventListener('DOMContentLoaded', function () {
  // 渐变出现
  const observerAnimationWrapper = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.remove('AnimationWrapper_opacity_0__W4ib0');
        entry.target.classList.remove('AnimationWrapper_transformy_20__SU0pm');
        entry.target.classList.add('AnimationWrapper_opacity_1__WrCmx');
        entry.target.classList.add('AnimationWrapper_transformy_0__m_64E');
      } else {
        // 元素离开视窗,恢复初始样式
        entry.target.classList.remove('AnimationWrapper_opacity_1__WrCmx');
        entry.target.classList.remove('AnimationWrapper_transformy_0__m_64E');
        entry.target.classList.add('AnimationWrapper_opacity_0__W4ib0');
        entry.target.classList.add('AnimationWrapper_transformy_20__SU0pm');
      }
    });
  });

  // 开始观察目标元素
  const AnimationWrapper = document.querySelectorAll('.AnimationWrapper_wrapper__SftXd')
  if (AnimationWrapper && AnimationWrapper.length) {
    AnimationWrapper.forEach(item => {
      observerAnimationWrapper.observe(item);
    })
  }
})
